/**
 * 파일명: privacyConsent.ko.js
 * 설명: 개인정보처리방침 전문 (한국어)
 *
 * 이 문서는 개인정보 보호법 제30조에 따라 "공개"하는 문서다. 동의 대상이 아니다.
 * 회원가입 시 동의를 받는 문서는 privacyCollect.ko.js 이다.
 *
 * 블록 구조
 *  - { type: "p",  text: "..." }        문단
 *  - { type: "ul", items: ["..."] }     글머리 목록
 *  - { type: "ol", items: ["..."] }     번호 목록
 */
const privacyConsentKo = {
  title: "개인정보처리방침",
  intro: [
    {
      type: "p",
      text: "(주)리브테크놀로지(이하 “회사”)는 「개인정보 보호법」 제30조에 따라 정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보처리방침을 수립·공개합니다.",
    },
    {
      type: "p",
      text: "○ 이 개인정보처리방침은 2026년 8월 4일부터 적용됩니다.",
    },
  ],
  sections: [
    {
      title: "제1조 (개인정보의 처리 목적)",
      blocks: [
        {
          type: "p",
          text: "회사는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 「개인정보 보호법」 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.",
        },
        {
          type: "ol",
          items: [
            "회원 가입 및 관리 : 회원 가입 의사 확인, 회원 식별 및 본인 확인, 소속 회사 단위의 이용 권한 관리, 관리자 승인 처리, 부정 이용 방지",
            "서비스의 제공 및 운영 : 회의실 예약, 회의실 장비 관리, 자율좌석, 화상회의 등 공간 운영 서비스의 제공",
            "고객 지원 : 고객 문의 대응, 서비스 관련 공지사항 및 안내사항 전달",
            "서비스 개선 : 회의실 및 좌석 사용 데이터의 통계 분석을 통한 서비스 품질 개선 (특정 개인을 식별할 수 없는 형태로 처리)",
          ],
        },
      ],
    },
    {
      title: "제2조 (처리하는 개인정보의 항목)",
      blocks: [
        {
          type: "p",
          text: "① 회사는 서비스 제공을 위하여 다음의 개인정보 항목을 처리하고 있습니다.",
        },
        { type: "p", text: "1. 회원 가입 및 관리" },
        {
          type: "ul",
          items: [
            "필수항목 : 이메일 주소, 회사명, 사용자 이름, 비밀번호",
          ],
        },
        {
          type: "p",
          text: "② 서비스 이용 과정에서 다음 정보가 자동으로 생성되어 수집될 수 있습니다.",
        },
        {
          type: "ul",
          items: [
            "접속 IP 주소, 접속 일시, 서비스 이용 기록, 브라우저 및 기기 정보, 쿠키",
          ],
        },
      ],
    },
    {
      title: "제3조 (개인정보의 처리 및 보유 기간)",
      blocks: [
        {
          type: "p",
          text: "① 회사는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.",
        },
        {
          type: "p",
          text: "② 회원 가입 및 관리와 관련한 개인정보는 수집·이용에 관한 동의일로부터 회원 탈퇴 시까지 제1조의 이용목적을 위하여 보유·이용합니다. 보유 근거는 정보주체의 동의(회원제 서비스 제공 및 이용자 식별)입니다.",
        },
        {
          type: "p",
          text: "③ 제2항에도 불구하고 관계 법령에 따라 보존 의무가 있는 경우에는 해당 기간까지 보관합니다.",
        },
        {
          type: "ul",
          items: [
            "소비자의 불만 또는 분쟁처리에 관한 기록 : 3년 (「전자상거래 등에서의 소비자보호에 관한 법률」)",
            "대금결제 및 재화 등의 공급에 관한 기록 : 5년 (「전자상거래 등에서의 소비자보호에 관한 법률」)",
            "계약 또는 청약철회 등에 관한 기록 : 5년 (「전자상거래 등에서의 소비자보호에 관한 법률」)",
            "표시·광고에 관한 기록 : 6개월 (「전자상거래 등에서의 소비자보호에 관한 법률」)",
          ],
        },
      ],
    },
    {
      title: "제4조 (개인정보의 제3자 제공)",
      blocks: [
        {
          type: "p",
          text: "① 회사는 정보주체의 개인정보를 제1조에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 「개인정보 보호법」 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.",
        },
        {
          type: "p",
          text: "② 회사는 현재 정보주체의 개인정보를 제3자에게 제공하고 있지 않습니다. 향후 제3자 제공이 필요한 경우에는 제공받는 자, 제공 목적, 제공하는 개인정보 항목, 제공받는 자의 보유·이용 기간을 정보주체에게 알리고 별도의 동의를 받겠습니다.",
        },
        {
          type: "p",
          text: "③ 회원이 소속된 회사의 관리자는 서비스 운영을 위하여 해당 회사에 소속된 회원의 이름, 이메일 주소, 회의실 예약 및 좌석 이용 내역 등을 확인할 수 있습니다. 이는 회원이 소속 회사 단위로 서비스를 이용함에 따른 것으로 제3자 제공에 해당하지 않습니다.",
        },
      ],
    },
    {
      title: "제5조 (정보주체와 법정대리인의 권리·의무 및 그 행사방법)",
      blocks: [
        {
          type: "p",
          text: "① 정보주체는 회사에 대해 언제든지 개인정보 열람·정정·삭제·처리정지 요구 등의 권리를 행사할 수 있습니다.",
        },
        {
          type: "p",
          text: "② 제1항에 따른 권리 행사는 「개인정보 보호법」 시행령 제41조제1항에 따라 서면, 전자우편 등을 통하여 하실 수 있으며 회사는 이에 대해 지체 없이 조치하겠습니다.",
        },
        {
          type: "p",
          text: "③ 제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우 「개인정보 처리 방법에 관한 고시」에 따른 위임장을 제출하셔야 합니다.",
        },
        {
          type: "p",
          text: "④ 개인정보 열람 및 처리정지 요구는 「개인정보 보호법」 제35조 제4항, 제37조 제2항에 의하여 정보주체의 권리가 제한될 수 있습니다.",
        },
        {
          type: "p",
          text: "⑤ 개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.",
        },
        {
          type: "p",
          text: "⑥ 회사는 정보주체 권리에 따른 열람의 요구, 정정·삭제의 요구, 처리정지의 요구 시 열람 등 요구를 한 자가 본인이거나 정당한 대리인인지를 확인합니다.",
        },
      ],
    },
    {
      title: "제6조 (개인정보의 파기)",
      blocks: [
        {
          type: "p",
          text: "① 회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.",
        },
        {
          type: "p",
          text: "② 정보주체로부터 동의받은 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 해당 개인정보를 별도의 데이터베이스로 옮기거나 보관장소를 달리하여 보존합니다.",
        },
        {
          type: "p",
          text: "③ 개인정보 파기의 절차 및 방법은 다음과 같습니다.",
        },
        {
          type: "p",
          text: "1. 파기절차 : 회사는 파기 사유가 발생한 개인정보를 선정하고, 회사의 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다.",
        },
        { type: "p", text: "2. 파기방법" },
        {
          type: "p",
          text: "전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용합니다.",
        },
        {
          type: "p",
          text: "종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.",
        },
      ],
    },
    {
      title: "제7조 (개인정보의 안전성 확보 조치)",
      blocks: [
        {
          type: "p",
          text: "회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.",
        },
        {
          type: "ol",
          items: [
            "정기적인 자체 감사 실시 : 개인정보 취급 관련 안정성 확보를 위해 정기적(분기 1회)으로 자체 감사를 실시하고 있습니다.",
            "개인정보 취급 직원의 최소화 및 교육 : 개인정보를 취급하는 직원을 지정하고 담당자에 한정시켜 최소화 하여 개인정보를 관리하는 대책을 시행하고 있습니다.",
            "내부관리계획의 수립 및 시행 : 개인정보의 안전한 처리를 위하여 내부관리계획을 수립하고 시행하고 있습니다.",
            "해킹 등에 대비한 기술적 대책 : 회사는 해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을 막기 위하여 보안프로그램을 설치하고 주기적인 갱신·점검을 하며 외부로부터 접근이 통제된 구역에 시스템을 설치하고 기술적·물리적으로 감시 및 차단하고 있습니다.",
            "개인정보의 암호화 : 이용자의 비밀번호는 암호화되어 저장 및 관리되고 있어 본인만이 알 수 있으며, 중요한 데이터는 파일 및 전송 데이터를 암호화하거나 파일 잠금 기능을 사용하는 등의 별도 보안기능을 사용하고 있습니다.",
            "접속기록의 보관 및 위변조 방지 : 개인정보처리시스템에 접속한 기록을 최소 1년 이상 보관·관리하고 있으며, 5만명 이상의 정보주체에 관하여 개인정보를 처리하거나 고유식별정보 또는 민감정보를 처리하는 경우에는 2년 이상 보관·관리하고 있습니다. 또한 접속기록이 위변조 및 도난, 분실되지 않도록 보안기능을 사용하고 있습니다.",
            "개인정보에 대한 접근 제한 : 개인정보를 처리하는 데이터베이스시스템에 대한 접근권한의 부여, 변경, 말소를 통하여 개인정보에 대한 접근통제를 위하여 필요한 조치를 하고 있으며 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있습니다.",
            "문서보안을 위한 잠금장치 사용 : 개인정보가 포함된 서류, 보조저장매체 등을 잠금장치가 있는 안전한 장소에 보관하고 있습니다.",
            "비인가자에 대한 출입 통제 : 개인정보를 보관하고 있는 물리적 보관 장소를 별도로 두고 이에 대해 출입통제 절차를 수립·운영하고 있습니다.",
          ],
        },
      ],
    },
    {
      title:
        "제8조 (개인정보 자동 수집 장치의 설치·운영 및 거부에 관한 사항)",
      blocks: [
        {
          type: "p",
          text: "① 회사는 이용자에게 개별적인 맞춤서비스를 제공하기 위해 이용정보를 저장하고 수시로 불러오는 ‘쿠키(cookie)’를 사용합니다.",
        },
        {
          type: "p",
          text: "② 쿠키는 웹사이트를 운영하는데 이용되는 서버(http)가 이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며 이용자들의 PC 컴퓨터내의 하드디스크에 저장되기도 합니다.",
        },
        {
          type: "p",
          text: "가. 쿠키의 사용 목적 : 로그인 상태 유지, 이용자가 방문한 각 서비스와 웹 사이트들에 대한 방문 및 이용형태, 보안접속 여부 등을 파악하여 이용자에게 최적화된 정보 제공을 위해 사용됩니다.",
        },
        {
          type: "p",
          text: "나. 쿠키의 설치·운영 및 거부 : 웹브라우저의 설정 메뉴(도구 > 인터넷 옵션 > 개인정보 등)에서 옵션을 설정하여 쿠키 저장을 거부할 수 있습니다.",
        },
        {
          type: "p",
          text: "다. 쿠키 저장을 거부할 경우 로그인 유지 등 맞춤형 서비스 이용에 어려움이 발생할 수 있습니다.",
        },
      ],
    },
    {
      title: "제9조 (만 14세 미만 아동의 개인정보)",
      blocks: [
        {
          type: "p",
          text: "회사는 만 14세 미만 아동의 개인정보를 수집하지 않으며, 만 14세 미만 아동은 서비스에 회원으로 가입할 수 없습니다.",
        },
      ],
    },
    {
      title: "제10조 (개인정보 보호책임자)",
      blocks: [
        {
          type: "p",
          text: "① 회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.",
        },
        { type: "p", text: "▶ 개인정보 보호책임자" },
        {
          type: "ul",
          items: [
            "성명 : 김용진",
            "직책 : CPO",
            "직급 : 이사",
            "연락처 : yj.kim@riv-tech.co.kr, 070-7798-1311",
          ],
        },
        { type: "p", text: "※ 개인정보 보호 담당부서로 연결됩니다." },
        { type: "p", text: "▶ 개인정보 보호 담당부서" },
        {
          type: "ul",
          items: [
            "부서명 : 정보보안팀",
            "담당자 : 김용진",
            "연락처 : yj.kim@riv-tech.co.kr, 070-7798-1311",
          ],
        },
        {
          type: "p",
          text: "② 정보주체께서는 회사의 서비스를 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의하실 수 있습니다. 회사는 정보주체의 문의에 대해 지체 없이 답변 및 처리해드릴 것입니다.",
        },
      ],
    },
    {
      title: "제11조 (개인정보 열람청구)",
      blocks: [
        {
          type: "p",
          text: "정보주체는 「개인정보 보호법」 제35조에 따른 개인정보의 열람 청구를 아래의 부서에 할 수 있습니다. 회사는 정보주체의 개인정보 열람청구가 신속하게 처리되도록 노력하겠습니다.",
        },
        { type: "p", text: "▶ 개인정보 열람청구 접수·처리 부서" },
        {
          type: "ul",
          items: [
            "부서명 : 정보보안팀",
            "담당자 : 김용진",
            "연락처 : yj.kim@riv-tech.co.kr, 070-7798-1311",
          ],
        },
      ],
    },
    {
      title: "제12조 (권익침해 구제방법)",
      blocks: [
        {
          type: "p",
          text: "정보주체는 개인정보침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회, 한국인터넷진흥원 개인정보침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다. 이 밖에 기타 개인정보침해의 신고·상담에 대하여는 아래의 기관에 문의하시기 바랍니다.",
        },
        {
          type: "ol",
          items: [
            "개인정보분쟁조정위원회 : (국번없이) 1833-6972 (www.kopico.go.kr)",
            "개인정보침해신고센터 : (국번없이) 118 (privacy.kisa.or.kr)",
            "대검찰청 : (국번없이) 1301 (www.spo.go.kr)",
            "경찰청 : (국번없이) 182 (ecrm.cyber.go.kr)",
          ],
        },
        {
          type: "p",
          text: "「개인정보 보호법」 제35조(개인정보의 열람), 제36조(개인정보의 정정·삭제), 제37조(개인정보의 처리정지 등)의 규정에 의한 요구에 대하여 공공기관의 장이 행한 처분 또는 부작위로 인하여 권리 또는 이익의 침해를 받은 자는 행정심판법이 정하는 바에 따라 행정심판을 청구할 수 있습니다.",
        },
        {
          type: "p",
          text: "※ 행정심판에 대해 자세한 사항은 중앙행정심판위원회(www.simpan.go.kr) 홈페이지를 참고하시기 바랍니다.",
        },
      ],
    },
    {
      title: "제13조 (개인정보처리방침의 변경)",
      blocks: [
        {
          type: "p",
          text: "① 이 개인정보처리방침은 2026년 8월 4일부터 적용됩니다.",
        },
        {
          type: "p",
          text: "② 회사가 개인정보처리방침을 변경하는 경우에는 변경 사항을 시행 7일 전부터 회사 홈페이지에 공지합니다. 다만 정보주체의 권리에 중요한 영향을 미치는 변경의 경우에는 시행 30일 전부터 공지합니다.",
        },
        {
          type: "p",
          text: "③ 이전의 개인정보처리방침이 필요한 경우에는 개인정보 보호 담당부서로 문의하시면 확인하실 수 있습니다.",
        },
      ],
    },
  ],
};

export default privacyConsentKo;
